import React from "react";
import {
  Code,
  Database,
  Activity,
  Layers,
  Monitor,
  Heart,
} from "react-feather";

import aboutimg from "../../assets/images/landingpage/abt-img.jpg";

const bottomFeatures = [
  { icon: Code, title: "Custom Software Development" },
  { icon: Heart, title: "Healthcare Software Solutions" },
  { icon: Monitor, title: "Web & Mobile Applications" },
  { icon: Layers, title: "CRM Systems" },
  { icon: Database, title: "Digital Transformation" },
  { icon: Activity, title: "System Integration" },
];

const AboutSection = () => {
  return (
    <section className="py-5 bg-light" id="about">
      <div className="container">

        <div className="row align-items-center">

          <div className="col-lg-5 mb-4 mb-lg-0">
            <div data-aos="fade-right">
              <h2 className="fw-bolder text-dark mb-3 fs-1">
                ABOUT <span className="lanp-secondary-text">AZSM</span> ENTERPRISES
              </h2>

              <p className="text-dark mb-3">
                AZSM Enterprises is a technology partner specializing in
                developing innovative healthcare software and driving
                digital transformation for forward-thinking organizations.
                We create custom software solutions, powerful web and
                mobile applications, and comprehensive healthcare systems
                that enhance patient care and operational efficiency.
              </p>

              <p className="text-dark mb-0">
                Our expertise spans from software architecture to data
                analytics, leveraging the latest in cloud computing to
                build robust digital hospital networks.
              </p>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="text-center" data-aos="zoom-in">
              <img
                src={aboutimg}
                alt="Healthcare System"
                className="img-fluid rounded shadow-lg"
              />
            </div>
          </div>

        </div>

        <div className="row mt-5 text-center" id="speciality">
          {bottomFeatures.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="col-6 col-lg-2 mb-4"
                 data-aos="zoom-in"
                 
              >
                <div className="lanp-bg-secondary rounded shadow-sm p-3 h-100 d-flex flex-column align-items-center justify-content-center">
                  <Icon size={28} className="mb-2 text-white" />
                  <small className="fw-semibold text-white">
                    {item.title}
                  </small>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default AboutSection;